import axios from 'axios';
import Cookies from 'js-cookie';

// Axios auth config 

const getConfig = () => { 

    const token = Cookies.get('jwt');

    const config = { 
        headers: {
            Authorization: `Bearer ${token}`,
        },
    }; 

    return config; 

}; 

// -- 

export const createCheckoutSession = async () => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/billing/checkout/session`, getConfig());

        return res; 
        
    } catch (error) {
        console.error('Error creating a checkout session:', error);
    }
};

// -- 

export const getGroupSubscription = async () => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/billing/subscription`, getConfig());

        return res; 
        
    } catch (error) {
        console.error('Error creating a group subscription:', error);
    }
};

// -- 

export const verifyCheckoutSession = async (sessionId: any) => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/billing/session/${sessionId}`, getConfig());

        return res; 
        
    } catch (error) {
        console.error('Error verifying a checkout session:', error);
    }
};

// -- 

export const getGroupInvoices = async () => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/billing/invoices`, getConfig());

        return res; 
        
    } catch (error) {
        console.error('Error retrieving group invoices:', error);
    }
};

// -- 

export const updateGroupSeats = async (seats: number) => {

    try {

        const content = { 
            seats: seats 
        }; 

        const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/billing/subscription/seats`, content, getConfig());

        return res; 
        
    } catch (error) {
        console.error('Error updating the group seats.', error);
    }
};

// -- 

export const cancelSubscription = async () => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/billing/subscription/cancel`, getConfig());

        return res; 
        
    } catch (error) {
        console.error('Error cancelling subscription.', error);
    }
};

// -- 

export const detachPaymentMethod = async () => {

    try {

        const res = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/billing/payment/method`, getConfig());

        return res; 
        
    } catch (error) {
        console.error('Error detaching payment method', error);
    }
};

// -- 

export const createSetupIntentSession = async () => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/billing/payment/intent`, getConfig());

        return res; 
        
    } catch (error) {
        console.error('Error creating a payment intent session.', error);
    }
};

// -- 

export const verifySetupIntentSession = async (setupIntentId: any) => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/billing/intent/${setupIntentId}`, getConfig());

        return res; 
        
    } catch (error) {
        console.error('Error verifying a payment intent session.', error);
    }
};








